import { db, firestore } from '../firebaseConfig';
import { doc, updateDoc, arrayUnion, collection, addDoc, serverTimestamp } from 'firebase/firestore';



export const sendContactMessage = async (user, title, message) => {
  if (!user || !message.trim()) throw new Error('Missing user or message text');

  const payload = {
    userId: user.uid,
    firstName: user.firstName,
    lastName: user.lastName,
    rank: user.rank,
    assignment: user.assignment,
    agency: user.agency,
    timestamp: serverTimestamp(),
    title: title || '',
    message: message.trim(),
    status: 'open'
  };

  const docRef = await addDoc(collection(firestore, 'contactMessages'), payload);
  return docRef.id;
};



export async function clearReminderPending(userId) {
  try {
    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      'reminderPending': false
    });
    console.log(`✅ Cleared reminderPending for ${userId}`);
  } catch (err) {
    console.error(`❌ Failed to clear reminderPending:`, err);
  }
}

/**
 * Cancels a user subscription and suspends their account.
 * @param {string} userId - Firebase Auth user ID
 */

export async function cancelSubscription(userId) {
  try {
    const userRef = doc(db, 'users', userId);

    await updateDoc(userRef, {
      'subscription.status': 'cancelled',
      'subscription.autoRenewal': false,
      'accountSuspended': true,
      activityLog: arrayUnion({
        date: new Date().toISOString(),
        type: 'cancellation',
        details: 'Subscription cancelled by user'
      })
    });

    console.log(`✅ Subscription cancelled for ${userId}`);
  } catch (err) {
    console.error(`❌ Failed to cancel subscription:`, err);
    throw err;
  }
}

export async function logPayment(userId, details = '') {
  try {
    const userRef = doc(db, 'users', userId);

    await updateDoc(userRef, {
      activityLog: arrayUnion({
        date: new Date().toISOString(),
        type: 'payment',
        details: 'Subscription renewal'
      })
    });

    console.log(`✅ Payment logged for ${userId}`);
  } catch (err) {
    console.error(`❌ Failed to log payment:`, err);
    throw err;
  }
}